<template>
  <div>
    <div class="orderboxs">
      <div class="orderbox">
        <div class="title">{{registermatchinfo.title}}</div>
        <div class="all">
          <div class="title">{{registermatchinfo.typename}}</div>
          <div class="body">{{registermatchinfo.fees}}</div>
        </div>
        <div class="discount" v-if="registermatchinfo.hascode==1">
          <label>折扣码</label>
          <input type="text" v-model="code" @change="changeCode" clearable placeholder="请输入折扣码" />
        </div>
        <div class="actual" v-if="registermatchinfo.hascode==1">
          <div class="title">实际支付</div>
          <div class="body">{{realpay}}</div>
        </div>
        <div class="order" v-if="registermatchinfo.needcheck!=1">当前报名需要审核</div>
      </div>
      <div class="form" v-for="items in memberAttrsValue" :key="items.id">
        <div class="content" v-for="item in items" :key="item.id">
          <div class="title">{{item.show_name}}</div>
          <div class="body">{{item.value}}</div>
        </div>
      </div>
    </div>
    <div class="footer apppadding button">
      <div class="btn">
        <Button plain type="info" @click="updateUse" size="large" round>重新选择</Button>
      </div>
      <div class="btn">
        <Button type="info" @click="signUp" size="large" round>确定支付</Button>
      </div>
    </div>
  </div>
</template>

<script>
import "./order.less";
import { Button } from "vant";
import {
  matchinfo,
  prePayorder,
  checkspeccode,
  submitpremembers,
  submitmemberinfos,
  registerpayorder
} from "@/libs/api";
import { getStorage, removeStorage } from "@/libs/utils";

export default {
  name: "userlist",
  components: {
    Button
  },
  data() {
    return {
      code: "",
      registermatchinfo: [],
      memberAttrsValue: [],
      realpay: "",
      postparams: []
    };
  },
  methods: {
    updateUse() {
      this.$router.push({
        name: "apply",
        params: {
          matchid: this.registermatchinfo.matchid,
          typeid: this.registermatchinfo.typeid
        },
        query: {
          rrid: this.$route.params.rrid,
          rgid: this.$route.params.rgid
        }
      });
    },
    signUp() {
      let userinfo = getStorage("userInfo");
      let urid = userinfo.urid;
      let token = userinfo.token;
      // let formid = 'the formId is a mock one'//怎么拿到？ !!
      // formsave({urid:urid,token:token,formid: formid})//不明白干嘛
      var matchinfo = this.registermatchinfo;
      var optionsparams = this.postparams;
      var params = {
        matchid: matchinfo.matchid,
        typeid: matchinfo.typeid,
        urid: urid,
        token: token,
        rgid: optionsparams.rgid,
        rrid: optionsparams.rrid,
        categoryid: matchinfo.categoryid
      };
      params.json = JSON.stringify(this.memberAttrsValue);
      submitpremembers(params).then(res => {
        if (res.status == 200) {
          delete params.json;
          params.riids = res.data.riids;
          submitmemberinfos(params).then(res => {
            if (res.status == 200) {
              delete params.riids;
              params.paytype = 2;
              params.paymethod = 1;
              params.returnurl = "wap";
              params.free = "free";
              if (
                this.code != "" &&
                this.code != undefined &&
                this.code != "undefined"
              ) {
                params.speccode = this.code;
              } else {
                delete params.speccode;
              }
              if (matchinfo.needcheck == 2) {
                registerpayorder(params).then(res => {
                  if (res.status == 200) {
                    this.regSuccess();
                  }
                });
              } else {
                this.$router.replace({ name: "mppay", params: params });
              }
            }
          });
        }
      });
    },
    regSuccess() {
      var typeid = this.postparams.typeid;
      var membervalue = "membervalue" + typeid;
      removeStorage(membervalue);
      this.$router.replace({ name: "myregister" });
    },
    changeCode() {
      checkspeccode({
        typeid: this.$route.params.typeid,
        matchid: this.$route.params.matchid,
        speccode: this.code
      }).then(res => {
        if (res.status == 200) {
          if (res.data.fees * 1 == 0) {
            res.data.fees = "免费";
          } else {
            res.data.fees = "¥" + res.data.fees;
          }

          this.realpay = res.data.fees;
          this.code = res.data.speccode;
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      let matchid = this.$route.params.matchid;
      let typeid = this.$route.params.typeid;
      let userinfo = getStorage("userInfo");
      let urid = userinfo.urid;
      let token = userinfo.token;
      var membervalue = "membervalue" + typeid;
      let memberinfo = getStorage(membervalue);
      if (memberinfo.length > 0) {
        var newvalue = [];
        memberinfo.forEach((item, index) => {
          if (item && item.list) {
            newvalue[index] = item.list;
          }
        });
        this.memberAttrsValue = newvalue;
      }
      this.postparams = this.$route.params;
      matchinfo({
        matchid: matchid,
        typeid: typeid,
        urid: urid,
        token: token,
        rgid: this.$route.params.rgid,
        rrid: this.$route.params.rrid
      }).then(res => {
        if (res.status == 200) {
          if (res.data.fees * 1 == 0) {
            res.data.fees = "免费";
          } else {
            res.data.fees = "¥" + res.data.fees;
          }
          this.registermatchinfo = res.data;
          this.realpay = res.data.fees;
        }
      });
    });
  }
};
</script>